'use client'

import { AlertTriangle, Info } from 'lucide-react'
import { useEffect, useState } from 'react'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@fp/ui-kit'
import { subscribeEmitDialog, type DialogBusProps, type DialogBusType } from '@lib/emitDialog'

const typeConfig: Record<DialogBusType, { icon: typeof AlertTriangle; iconClass: string }> = {
  warning: { icon: AlertTriangle, iconClass: 'text-warning' },
  error: { icon: AlertTriangle, iconClass: 'text-destructive-foreground' },
  info: { icon: Info, iconClass: 'text-primary' },
}

export function GlobalDialogListener() {
  const [dialogProps, setDialogProps] = useState<DialogBusProps | null>(null)

  useEffect(() => {
    const unsubscribe = subscribeEmitDialog((props) => setDialogProps(props))

    return unsubscribe
  }, [])

  if (!dialogProps) return null

  const config = typeConfig[dialogProps.type ?? 'info']
  const Icon = config.icon

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) {
          dialogProps.onClose?.()
          setDialogProps(null)
        }
      }}
    >
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle className='flex items-center gap-2'>
            <Icon className={`size-5 ${config.iconClass}`} />
            {dialogProps.title}
          </DialogTitle>
        </DialogHeader>
        {dialogProps.content}
      </DialogContent>
    </Dialog>
  )
}
